import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Pagination } from "@/components/molecules/Pagination";
import { PaginationType } from "@/models/common";
import { TableContainer } from "@mui/material";
import { CarNoopEventsConstants } from "./CarNoopEventsConstants";
import { CommonButton } from "@/components/common/buttons/CommonButton";
import { EvCarNoopEvents } from "@/models/carUnderuseEvents";
import { formatDateStr, getShortDatetime } from "@/util/datetime";

export type CarNoopEventsListProps = {
  editable: boolean;
  onChangePage: (page: number) => void;
  pagingData: PaginationType;
  events: EvCarNoopEvents[];
  onClickEdit: (id: number) => void;
};

export const CarNoopEventsList = (props: CarNoopEventsListProps) => {
  const {
    editable,
    onChangePage,
    onClickEdit,
    events,
    pagingData,
  } = props;

  return (
    <React.Fragment>
      <TableContainer className="table-container-width">
        <Table size="small" className="list-head">
          <TableHead>
            <TableRow>
              <TableCell>
                {CarNoopEventsConstants.Company}
              </TableCell>
              <TableCell>
                {CarNoopEventsConstants.Office}
              </TableCell>
              <TableCell>
                {CarNoopEventsConstants.RadioNumber}
              </TableCell>
              <TableCell>
                {CarNoopEventsConstants.PlateNumber}
              </TableCell>
              <TableCell>
                {CarNoopEventsConstants.NoopStartDate}
              </TableCell>
              <TableCell colSpan={2}>
                {CarNoopEventsConstants.EventAt}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((row) => (
              <TableRow key={row.eventId} hover sx={{ wordBreak: "break-all" }}>
                <TableCell>
                  {row.companyName}
                </TableCell>
                <TableCell>
                  {row.officeName}
                </TableCell>
                <TableCell>
                  {row.vehicleCode}
                </TableCell>
                <TableCell>
                  {row.plateNumberText ?? ""}
                </TableCell>
                <TableCell>
                  {formatDateStr(row.noopStartDate)}
                </TableCell>
                <TableCell>
                  {getShortDatetime(row.eventAt)}
                </TableCell>
                <TableCell sx={{ textAlign: "right", pr: 0 }}>
                  <CommonButton
                    btnType="RegisterReason"
                    onClickBtn={() => onClickEdit(row.eventId || 0)}
                    disabled={!editable}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        total={pagingData.total}
        page={pagingData.page}
        size={pagingData.size}
        setPage={onChangePage}
      />
    </React.Fragment>
  );
};
